module.exports = __webpack_public_path__ + "static/media/31.cce875a1.jpg";